import { createFileRoute } from '@tanstack/react-router';
import { UserForm } from '@/components/users/UserForm.tsx';

export const Route = createFileRoute('/_app/users/$id/edit')({
  staticData: { orgScope: 'record', orgScopeList: '/users' },
  component: EditUserPage,
});

function EditUserPage() {
  const { id } = Route.useParams();

  return <UserForm userId={id} />;
}
